<script lang="ts">
    import Chevron from "../../common/Chevron.svelte";

    export let title: string;
</script>


<div class="ivdemo-timeline-track-head">
    <Chevron style="float: left; font-size:1rem; line-height:100%;"/>
    {title}
    <div id="ivdemo-timeline-track-head-opt">
    </div>
</div>

<style>
.ivdemo-timeline-track-head {
        color: white;
        font-size: 0.8rem;
        font-variant: all-caps;
        width: 160px;
        border-right: 1px #999999 solid;
        text-align: right;
        left: 0;
        background-color: #555555;
        border-bottom: 1px #999999 solid;
        user-select: none;
    }
</style>

